// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3OtXK","title":"Info_title__2KTMt","links":"Info_links__2iRhE","link":"Info_link__3DCf4","logo":"Info_logo__3f5KB"};